import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { myTaskService } from '../../services';
import { history } from 'routes/history';

const initialState = {
  data: {},
  detailData: {},
  filter: {
    dateCreated: '',
    objectId: '',
    objectName: '',
    referenceNumber: '',
  },
  statusList: 'idle',
  statusDetail: '',
  statusSubmit: '',

  rejectReasonList: [],
  rejectReasonStatus: '',
};

export const getListEkycAction = createAsyncThunk(
  'ekyc/getList',
  async (payload) => {
    const res = await myTaskService.getListEkyc(payload);
    return res;
  },
);

export const getDetailEkycAction = createAsyncThunk(
  'ekyc/getDetail',
  async (id) => {
    const res = await myTaskService.getDetailEkyc(id);
    return res;
  },
);

export const getDroplistReasonAction = createAsyncThunk(
  'ekyc/getDroplist',
  async () => {
    const res = await myTaskService.getDroplistReason();
    return res;
  }
);

export const submitTaskAction = createAsyncThunk(
  'ekyc/submitTaskAction',
  async (option) => {
    const res = myTaskService.taskAction(option);
    return res;
  },
);

export const myTaskEkycSlice = createSlice({
  name: 'ekyc',
  initialState: initialState,
  reducers: {
    setFilter: (state, action) => {
      const data = action.payload;
      state.filter = data;
    },
    resetAllData: () => {
      return initialState;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if (typeof payload === 'string') {
        state[payload] = initialState[payload];
      } else if (Array.isArray(payload)) {
        payload.forEach((item) => (state[item] = initialState[item]));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListEkycAction.pending, (state) => {
        state.statusList = 'loading';
      })
      .addCase(getListEkycAction.fulfilled, (state, action) => {
        state.statusList = 'success';
        state.data = action.payload;
        if (state.data && state.data.number && state.data.number > 0) {
          history.push(`/approval_ekyc?page=${state.data.number + 1}`);
        } else {
          history.replace('/approval_ekyc');
        }
      })
      .addCase(getListEkycAction.rejected, (state) => {
        state.statusList = 'error';
      })
      .addCase(getDetailEkycAction.pending, (state) => {
        state.statusDetail = 'loading';
      })
      .addCase(getDetailEkycAction.fulfilled, (state, action) => {
        state.statusDetail = 'success';
        state.detailData = action.payload;
      })
      .addCase(getDetailEkycAction.rejected, (state) => {
        state.statusDetail = 'error';
      })
      .addCase(submitTaskAction.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(submitTaskAction.fulfilled, (state, action) => {
        state.statusSubmit = 'success';
      })
      .addCase(submitTaskAction.rejected, (state) => {
        state.statusSubmit = 'error';
      })
      .addCase(getDroplistReasonAction.pending, (state) => {
        state.rejectReasonStatus = 'loading';
      })
      .addCase(getDroplistReasonAction.fulfilled, (state, action) => {
        state.rejectReasonStatus = 'success';
        state.rejectReasonList = action.payload;
      })
      .addCase(getDroplistReasonAction.rejected, (state) => {
        state.rejectReasonStatus = 'error';
      });
  },
});

export const { setFilter, resetAllData, resetData } = myTaskEkycSlice.actions;

const myTaskEkycReducer = myTaskEkycSlice.reducer;
export default myTaskEkycReducer;